import React, { useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import Pagination from "../../../../components/Pagination";
import { toast } from "react-toastify";
import { Modal as AntModal } from "antd";
import Modal from "react-modal";

const ServiceMasterList = (props) => {
  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [itemsPerPage] = useState(10);

  const { sendRequest: deleteOperation } = useHttp();

  const handleDelete = (e, serviceId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this service detail?",
      onOk() {
        deleteOperation(
          {
            url: `/api/serviceMaster/?orgId=${localStorage.getItem(
              "orgId"
            )}&serviceId=${serviceId}`,
            method: "DELETE",
          },
          (data) => {
            if (data.success) {
              toast.success(data.success);
            }

            if (data.error) {
              toast.error(data.error);
            }

            FillDetail();
          },
          (error) => {
            toast.error(error);
          }
        );
      },
      onCancel() {},
    });
  };

  const { sendRequest: getMarketData } = useHttp();

  const FillDetail = () => {
    getMarketData(
      {
        url: `/api/serviceMaster/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          const sortedData = res?.sort((a, b) => b.serviceId - a.serviceId);
          setData(sortedData);
          setAllData(sortedData);
          
        }
      }
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getMarketData]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

 
  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.moduleName.toLowerCase().includes(filetrtext) ||
        item.serviceSubName.toLowerCase().includes(filetrtext) ||
        item.serviceUrl.toLowerCase().includes(filetrtext) ||
        item.serviceName.toLowerCase().includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-9">
            <label className="card-title  my-3">
              {" "}
              &nbsp; &nbsp;Service Master Details{" "}
            </label>{" "}
          </div>

          <div className="col-3 text-right">
            <button
              type="button"
              className="btn  btn-primary my-2"
              onClick={() => {
                addForm(true);
               
                props.update(false);
              }}
            >
              Add Service
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-9"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          placeholder="Search..."
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Module Name</th>
                            <th>Sub Service Name</th>
                            <th>Service Name</th>
                            <th>Service Url</th>
                            <th>Edit</th>
                            <th>Delete</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.moduleName}</td>
                                <td>{x.serviceSubName}</td>
                                <td>{x.serviceName}</td>
                                <td>{x.serviceUrl}</td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => {
                                      props.update(x);
                                      props.addForm(true);
                                    }}
                                  >
                                    {" "}
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={(e) =>
                                      handleDelete(e, x.serviceId)
                                    }
                                  >
                                    {" "}
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ServiceMasterList;
